<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Born and bred in the Eastern Cape of South Africa on the foothills of the Stormberg mountains, Stephan spent most of his childhood exploring the rivers and mountains surrounding the hometown of Burghersdorp. Stephan had qualified as a paratrooper with the South African Defence force before his eighteen birthday and returned home a year later as a seasoned mercenary.</p><br/>
<p style="text-indent:0em;">After qualifying as an electronic engineer, he specialised in military communication systems. Stephan worked across Africa and Asia where he survived many life-threatening situations.</p><br/>
<p style="text-indent:0em;">It was during the first COVID lockdown that he decided to seriously put pen to paper.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?57b5e0d6